const UPDATE_TOKEN_AND_USER_DATA = "UPDATE_TOKEN_AND_USER_DATA";
const UPDATE_USER_DATA = "UPDATE_USER_DATA";
const USER_ALREADY_EXISTS = "USER_ALREADY_EXISTS";
const USER_NOT_FOUND = "USER_NOT_FOUND";
const USER_LOGOUT = "USER_LOGOUT";
const INVALID_USER_INPUT = "INVALID_USER_INPUT";
export {
  UPDATE_TOKEN_AND_USER_DATA,
  UPDATE_USER_DATA,
  USER_ALREADY_EXISTS,
  USER_NOT_FOUND,
  USER_LOGOUT,
  INVALID_USER_INPUT,
};
